import script from "./alert.vue?vue&type=script&setup=true&lang=js"
export * from "./alert.vue?vue&type=script&setup=true&lang=js"

import "./alert.vue?vue&type=style&index=0&id=1594eb46&lang=scss"

const __exports__ = script;

export default __exports__